export default "__VITE_ASSET__CtmH4yo3__"